<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
   mounted() {
    document.title = '心鉴智愈';
  }
}
</script>

<style>
#app {
  font-family: "SourceHanSansCN-Regular", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}
:root {
    --primary-color: #7035e6;
    --primary-color-lighter: #8a5eff;
    --secondary-color: #10b981;
    --secondary-color-lighter: #36ecb0;
}
html {
  font-size: 16px;
  touch-action: manipulation;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

@media screen and (max-width: 768px) {
  html {
    font-size: 14px;
  }
  
  /* 移动端安全区域适配 */
  body {
    /* 确保安全区域变量可用 */
    padding-top: env(safe-area-inset-top, 0);
    padding-bottom: env(safe-area-inset-bottom, 0);
    padding-left: env(safe-area-inset-left, 0);
    padding-right: env(safe-area-inset-right, 0);
  }
  
  /* 确保所有返回按钮有足够的点击区域（至少44x44px） */
  .back-button,
  button.back-button,
  .el-button.back-button {
    min-width: 44px !important;
    min-height: 44px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
}
</style>